// src/api/sync.js
import { supabase } from '../supabaseClient';
import { debug } from '../helpers/debug';

/**
 * Check if a project has been updated since a given timestamp
 * @param {number} projectId - The project ID
 * @param {string} sinceTime - ISO timestamp to check against
 * @returns {Promise<Object>} - { isUpdated: boolean, updated_at: string }
 */
export async function apiCheckProjectUpdates(projectId, sinceTime) {
  try {
    const { data, error } = await supabase
      .from('projects')
      .select('id, updated_at')
      .eq('id', projectId)
      .gt('updated_at', sinceTime)
      .maybeSingle();

    if (error) throw error;

    return {
      isUpdated: !!data,
      updated_at: data?.updated_at || null
    };
  } catch (err) {
    debug('[API] checkProjectUpdates error:', { type: 'error' }, err);
    return { isUpdated: false, updated_at: null };
  }
}

/**
 * Check which docs have been updated since a given timestamp
 * @param {Array<number>} docIds - Array of doc IDs to check
 * @param {string} sinceTime - ISO timestamp to check against
 * @returns {Promise<Object>} - { updatedDocs: Array<number> }
 */
export async function apiCheckDocsUpdates(docIds, sinceTime) {
  if (!docIds || docIds.length === 0) {
    return { updatedDocs: [] };
  }

  try {
    const { data, error } = await supabase
      .from('docs')
      .select('id, updated_at')
      .in('id', docIds)
      .gt('updated_at', sinceTime);

    if (error) throw error;

    return {
      updatedDocs: data ? data.map(doc => doc.id) : []
    };
  } catch (err) {
    debug('[API] checkDocsUpdates error:', { type: 'error' }, err);
    return { updatedDocs: [] };
  }
}

